export default class DefaultPlayer {
  constructor(mediaElement, manifestUrl) {
    
    this.mediaElement_ = mediaElement
    this.manifestUrl_ = manifestUrl

    /** @protected */
    this.player_ = null
    this.displayTime = null
    // this.addListeners()
  }
  
  initialize() {
    console.log("Initialize player:", this.playerName_)
  }

  switching() {
    if (this.isPaused) this.play()
    else this.pause()
  }

  //promise
  play() { 
    return this.mediaElement_.play() 
  }

  isPlaying() {
    return this.isPlaying
  }

  isPaused() {
    return this.mediaElement_.paused
  }

  isSeeking() {
    return this.mediaElement_.seeking
  }

  stop() {
    
  }

  pause() {
    this.mediaElement_.pause()
  }

  // promise
  detach() {
    return this.mediaElement_.detach()
  }

  // promise
  attach() {
    return this.mediaElement_.attach(this.manifestUrl)
  }

  // promise
  load() {
    return new Promise((resolve) => {
      this.mediaElement_.load()
      resolve()
    })
  }

  //promise
  unload(manifestUrl) {

  }

  async destroy() {
    if (this.player_) {
      this.detach()
      this.player_.destroy()
      this.player_ = null
    }
  }

  isLive() {
    
  }

  ff(sec) {
    this.mediaElement_.currentTime + sec
  }

  rew(sec) {
    this.mediaElement_.currentTime - sec
  }

  // Get playhead timestamp from current video
  currentTime() {
    return this.mediaElement_.currentTime
  }

  // Get total duration from current video
  duration() {
    return this.mediaElement_.duration
  }
  
  seekRange() {
    return {
      start: this.mediaElement_.seekable.start(0),
      end: this.mediaElement_.seekable.end(this.mediaElement_.seekable.length - 1)
    }
  }

  /**
  * calc display time
  * @private 
  */
  calcDisplayTime() {
    let displayTime = this.currentTime()
    const duration = this.duration()
    const seekRange = this.seekRange()
    const isSeeking = this.isSeeking()

    if (player.isLive()) {
      const behindLive = Math.floor(seekRange.end - displayTime)
      displayTime = Math.max(0, behindLive)

      const showHour = seekRange >= 3600
      
      if (displayTime >= 1 || isSeeking) {
        this.setCurrentTime('- ' + this.buildTimeString(displayTime, showHour))
      } else {
        this.setCurrentTime('LIVE')
      }
    } else {
      const showHour = duration >= 3600
      
      let value = this.buildTimeString(displayTime, showHour)
      if (duration) {
        value += ' / ' + this.buildTimeString(duration, showHour)
      }
      this.setCurrentTime(value)
    }
  }

  buildTimeString(displayTime, showHour) {
    const h = Math.floor(displayTime / 3600)
    const m = Math.floor((displayTime / 60) % 60)
    let s = Math.floor(displayTime % 60)

    if (s < 10) {
      s = '0' + s
    }
    let text = m + ':' + s
    if (showHour) {
      if (m < 10) {
        text = '0' + text
      }
      text = h + ':' + text
    }
    return text
  }

  setCurrentTime(timeStamp) {
    this.displayTime = timeStamp
  }

  addListeners() {
    // todo
  }

  onError(error) {
    // 에러 발생시 플레이어 강제 종료
    console.error('error occurred', error)
    if (this.player_) this.destroy()
  }
}